import Vue from "vue";
import Vuex from "vuex";
import shipment from "./modules/shipment";
import createLogger from "vuex/dist/logger";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

//const debug = process.env.NODE_ENV !== "production";
const debug = false;

const persist = new VuexPersistence({
    modules: ["shipment"],
    storage: window.sessionStorage,
    key: "shipment",
});

let store = {
    state: {
        showHeaderBackButton: true,
        showHeaderHelpButton: true,
        enableHeaderHomeButton: true,
        subHeaderText: '',
        showSubHeaderPanel: false,
        eventMessages: [],
        maxWidth: 0,
        smsCode: null,
        nextRoute: null,
        finalTitle: null,
        finalText: null
    },
    getters: {
        nextRoute: (state) => state.nextRoute,
        finalTitle: (state) => state.finalTitle,
        finalText: (state) => state.finalText,
    },
    mutations: {
        SET_HEADER_BACK_BUTTON(state, payload) {
            state.showHeaderBackButton = payload;
        },
        SET_HEADER_HELP_BUTTON(state, payload) {
            state.showHeaderHelpButton = payload;
        },
        SET_HEADER_ENABLE_HOME_BUTTON(state, payload) {
            state.enableHeaderHomeButton = payload;
        },
        SET_SUB_HEADER_TEXT(state, payload) {
            state.subHeaderText = payload;
        },
        SET_SHOW_SUB_HEADER_PANEL(state, payload) {
            state.showSubHeaderPanel = payload;
        },
        ADD_EVENT_MESSAGE(state, payload) {
            state.eventMessages.unshift({
                message: payload,
                id: Date.now() + '.' + Math.random(),
            });
            setTimeout(() => state.eventMessages.pop(), 5000);
        },
        SET_SMS_CODE: (state, p) => {
            state.smsCode = p;
        },
        SET_NEXT_ROUTE: (state, p) => {
            state.nextRoute = p;
        },
        SET_FINAL_TITLE: (state, p) => {
            state.finalTitle = p;
        },
        SET_FINAL_TEXT: (state, p) => {
            state.finalText = p;
        }
    },
    actions: {
        setHeaderBackButton({ commit }, payload) {
            commit('SET_HEADER_BACK_BUTTON', payload);
        },
        setHeaderHelpButton({ commit }, payload) {
            commit('SET_HEADER_HELP_BUTTON', payload);
        },
        setHeaderEnableHomeButton({ commit }, payload) {
            commit('SET_HEADER_ENABLE_HOME_BUTTON', payload);
        },
        setSubHeaderText({ commit }, payload) {
            commit('SET_SUB_HEADER_TEXT', payload);
        },
        setShowSubHeaderPanel({ commit }, payload) {
            commit('SET_SHOW_SUB_HEADER_PANEL', payload);
        },
        addEventMessage({ commit }, payload) {
            commit('ADD_EVENT_MESSAGE', payload);
        },
        setSmsCode({ commit }, payload) {
            commit('SET_SMS_CODE', payload);
        },
        setNextRoute({ commit }, payload) {
            commit('SET_NEXT_ROUTE', payload);
        },
        setFinalTitle({ commit }, payload) {
            //console.log('setFinalTitle', payload);
            commit('SET_FINAL_TITLE', payload);
        },
        setFinalText({ commit }, payload) {
            //console.log('setFinalText', payload);
            commit('SET_FINAL_TEXT', payload);
        }
    }
};

export default new Vuex.Store({
    ...store,
    modules: {
        shipment,
    },
    strict: debug,
    plugins: debug ? [persist.plugin, createLogger()] : [persist.plugin],
});
